
export class ExtendableError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}

export class FetchError extends ExtendableError {
  constructor(message, res) {
    super(message);
    this.res = res;
  }
}



// WEBPACK FOOTER //
// ./src/utils/error.js